'use client';

import Icon from './Icon';
import svg from 'sprites/app-store.svg';

export default function IconAppStore({
  className = 'w-3.5 h-4 fill-graphite stroke-none'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
